import {MOBILE_POS_SCAN_LOG} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,
  
  selectedData: null,
  formType: "",
  formTitle: "",
  formId: "",

  showModalExport: false,
  isExportStarting: false,
  isExporting: false,
  isExportSuccess: false,
  isExportError: false,
  exportPercentage: 0,
  fileConfig: {
    filename: "",
    blob: ""
  },
  errorMessage: "",

  memberId: [],
  startDate: "",
  endDate: ""
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case MOBILE_POS_SCAN_LOG:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/MobilePOSScanLog.js